import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { useMainResearch } from "utils/clientAPIs/discuss";
import SkeletonBlock from "components/skeleton";
import useWindowWidth from "utils/useWindowWIdth";
import ReportThumb from "../../components/ReportThumb";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";
import { TrackedLink } from "lib/analytics/react/link";

function MainResearch({ isMobile }: { isMobile: boolean }) {
  const [data, isLoading] = useMainResearch();
  const router = useRouter();
  const { t } = useTranslation("main");

  const currentWidth = useWindowWidth();

  if (isLoading)
    return (
      <div className="px-6 pt-6 pb-[72px]">
        <SkeletonBlock width={"100%"} height={420} />
      </div>
    );

  if (isMobile || currentWidth < 560) {
    return (
      <div className="px-6 pt-6 pb-[72px]">
        {" "}
        <div className="p-5 flex flex-col gap-5 bg-gray2 border border-gray5 rounded-[20px] items-center">
          <div className="flex flex-col gap-1 text-center">
            <p className={`${TYPO.TYPO7_1_RG} text-gray70 leading-[22px]`}>
              {t("weeklyAiReport")}
            </p>
            <p
              className={`${TYPO.TYPO3_SB} text-gray90 leading-[32px] break-keep text-center line-clamp-2`}
            >
              {data.title}
            </p>
          </div>

          <ReportThumb
            data={data}
            className="w-full  bg-gray20 rounded-[16px]"
          />
          <TrackedLink
            href={`/discuss/${
              data?.url_slug ? `${data?.url_slug}-${data?.id}` : data?.id
            }`}
            asTrace={true}
            fromListId="feed_weekly_ai_reports"
            itemspec={{
              kind: "report",
              report_id: data?.id,
            }}
            data-gtm-id={`cAgendaMain`}
            className="!bg-white border border-gray15 w-full !!text-black  gap-1 flex justify-center items-center   h-12 px-4 py-[11px] rounded-xl   text-[17px] font-medium leading-[26px] !cursor-pointer "
          >
            <p>{t("checkNow")}</p>
          </TrackedLink>
        </div>
      </div>
    );
  }
  return (
    <div className="px-6 pt-6 pb-[72px]">
      <div className="p-5 flex gap-5 bg-gray2 border border-gray5 rounded-[20px] items-center">
        <ReportThumb
          data={data}
          className="w-full  bg-gray20 rounded-[16px] max-w-[55%]"
        />
        <div className="flex flex-col gap-4 ">
          <div className="flex flex-col gap-1 text-center">
            <p className={`${TYPO.TYPO7_1_RG} text-gray70 leading-[22px]`}>
              {t("weeklyAiReport")}
            </p>
            <p
              className={`${TYPO.TYPO3_SB} text-gray90 leading-[32px] break-keep text-center line-clamp-2`}
            >
              {data.title}
            </p>
          </div>
          <TrackedLink
            href={`/discuss/${
              data?.url_slug ? `${data?.url_slug}-${data?.id}` : data?.id
            }`}
            asTrace={true}
            itemspec={{
              kind: "report",
              report_id: data?.id,
            }}
            data-gtm-id={`cAgendaMain`}
            className="!bg-white border border-gray15 w-full !!text-black  gap-1 flex justify-center items-center   h-12 px-4 py-[11px] rounded-xl   text-[17px] font-medium leading-[26px] !cursor-pointer "
            onClick={() => {
              router.push(
                `/discuss/${
                  data?.url_slug ? `${data?.url_slug}-${data?.id}` : data?.id
                }`
              );
            }}
          >
            <p>{t("checkNow")}</p>
          </TrackedLink>
        </div>
      </div>
    </div>
  );
}

export const VoteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M5.85938 23.1969H42.126V39.4635C42.126 41.5254 40.4546 43.1969 38.3927 43.1969H9.59271C7.53084 43.1969 5.85938 41.5254 5.85938 39.4635V23.1969Z"
        fill="#3D8AEF"
      />
      <path
        d="M9.78094 13.5715C10.6312 11.6415 12.5345 10.3968 14.6353 10.3969L33.1485 10.3973C35.2101 10.3974 37.0852 11.5966 37.9578 13.473L41.7975 21.7296C42.8664 24.028 41.1965 26.6635 38.6714 26.6635H9.31374C6.81905 26.6635 5.1488 24.0858 6.15849 21.794L9.78094 13.5715Z"
        fill="#70A9F5"
      />
      <path
        d="M15.1927 17.8635C15.1927 17.1272 15.7897 16.5302 16.526 16.5302H31.4594C32.1958 16.5302 32.7927 17.1272 32.7927 17.8635C32.7927 18.5999 32.1958 19.1969 31.4594 19.1969H16.526C15.7897 19.1969 15.1927 18.5999 15.1927 17.8635Z"
        fill="#2867DA"
      />
      <path
        d="M16.526 6.13021C16.526 5.39383 17.123 4.79688 17.8594 4.79688H30.126C30.8624 4.79688 31.4594 5.39383 31.4594 6.13021V17.8635H16.526V6.13021Z"
        fill={TAILWIND_TO_CSS["gray15"]}
      />
    </svg>
  );
};
export default MainResearch;
